import { sessionStorageAdapter } from './secureStorage';

/**
 * Номер этого устройства — чтобы школа видела, у кого доступ на десяти телефонах.
 *
 * ⚠️ ЭТО СВОЙ СЛУЧАЙНЫЙ НОМЕР, А НЕ ОТПЕЧАТОК ЖЕЛЕЗА. Снимать характеристики
 * устройства и склеивать из них опознаватель Apple запрещает прямо; случайный
 * номер, заведённый приложением при установке, — обычная и разрешённая
 * практика. Он ничего не говорит о самом телефоне.
 *
 * ⚠️ ПО НЕМУ СЧИТАЮТ, А НЕ БЛОКИРУЮТ (решение владельца 31.08.2026). Номер
 * переживает выход и вход, но НЕ переживает переустановку приложения и чистку
 * браузера. Жёсткий отказ по такому счётчику дал бы поток обращений «я всё
 * удалил, а меня не пускают».
 *
 * ⚠️ ПОЧЕМУ НЕ ПО АДРЕСУ В СЕТИ. Проверено на боевом: 43 живые сессии у шести
 * человек, 70 веб-сессий всего с девяти адресов. Мобильный интернет меняет
 * адрес по десять раз на дню, а за одним адресом сидит целая школа.
 */
const KEY = 'onebilim.deviceId';

let cached: string | null = null;

export async function getDeviceId(): Promise<string> {
  if (cached) return cached;

  try {
    const stored = await sessionStorageAdapter.getItem(KEY);
    if (stored) {
      cached = stored;
      return stored;
    }
  } catch {
    // Хранилище недоступно — заведём новый номер ниже. Он не переживёт
    // перезапуск, но это несравнимо лучше, чем отказать человеку во входе.
  }

  const fresh = newId();
  cached = fresh;
  try {
    await sessionStorageAdapter.setItem(KEY, fresh);
  } catch {
    /* см. выше: номер уже выдан, приложение работает */
  }
  return fresh;
}

/**
 * Случайный номер. `randomUUID` есть не везде (старый WebView, небезопасный
 * контекст), поэтому запасной путь — из случайных байтов той же формы.
 */
function newId(): string {
  try {
    if (typeof crypto !== 'undefined' && typeof crypto.randomUUID === 'function') {
      return crypto.randomUUID();
    }
  } catch {
    /* падаем в запасной путь */
  }
  const bytes = new Uint8Array(16);
  crypto.getRandomValues(bytes);
  bytes[6] = (bytes[6] & 0x0f) | 0x40;
  bytes[8] = (bytes[8] & 0x3f) | 0x80;
  const hex = Array.from(bytes, (b) => b.toString(16).padStart(2, '0')).join('');
  return `${hex.slice(0, 8)}-${hex.slice(8, 12)}-${hex.slice(12, 16)}-${hex.slice(16, 20)}-${hex.slice(20)}`;
}

/** Только для проверок: забыть номер, как после перезапуска приложения. */
export function __resetDeviceIdForTests(): void {
  cached = null;
}
